<div class="container section">
  <div class="row pagetitle-row">
    <div class="pagetitle">
      <div class="nav-icons membership"><i class="fa fa-chevron-up fa-2x" aria-hidden="true"></i></div>
      <h1 class="membership">Membership</h1>
    </div>
	<!-- <div class="nav-arrow">
		<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
	</div> -->
  </div>
  <form class="full-width" novalidate (ngSubmit)="save()" [formGroup]="membershipForm">

    <div id="memberTypeCtr">
      <h3>Member Type</h3>
      <div class="row">
        <div class="radioBlock">
          <div [class]="memberTypeFirstClassNames">
            <input type="radio" id="mt_medstu" [value]="MemberType.Student" (change)="setValidation()" name="memberType" formControlName="memberType">
            <label for="mt_medstu">Medical Student</label>
          </div>

          <div [class]="memberTypeClassNames">
            <input type="radio" id="mt_res" [value]="MemberType.Resident" (change)="setValidation()" name="memberType" formControlName="memberType">
            <label for="mt_res">Resident Physician</label>
          </div>

          <div [class]="memberTypeClassNames">
            <input type="radio" id="mt_fell" [value]="MemberType.Fellow" (change)="setValidation()" name="memberType" formControlName="memberType">
            <label for="mt_fell">Fellowship Physician</label>
          </div>

          <div [class]="memberTypeClassNames">
            <input type="radio" id="mt_em" [value]="MemberType.Physician" (change)="setValidation()" name="memberType" formControlName="memberType">
            <label for="mt_em">EM Physician</label>
          </div>

          <div [class]="memberTypeClassNames" *ngIf="isRetiredMember">
            <input type="radio" id="mt_rt" [value]="MemberType.Retired" (change)="setValidation()" name="memberType" formControlName="memberType">
            <label for="mt_rt">Semi-Retired/Retired</label>
          </div>
        </div>
      </div>

      <mat-error *ngIf="formSubmitted && memberType.errors?.required">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
        </mat-error>

      <div class="validationwrap" [class.validation-error]="attest.invalid && (attest.dirty || attest.touched || formSubmitted)">
          <mat-checkbox *ngIf="isRetiredMember && memberType.value === MemberType.Retired" color="primary" required formControlName="attest" [class.validation-error]="attest.invalid && (attest.dirty || attest.touched || formSubmitted)"><strong>By selecting this membership option, I attest I work less than 280 hours annually and meet the ACEP membership requirement outlined in the ACEP Bylaws.</strong></mat-checkbox>
          <span class="validationhead"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
      </div>
    </div>

    <div id='military' *ngIf="!(isRetiredMember && memberType.value === MemberType.Retired) && !isInternationalMember">
      <h3>Military</h3>
      <p>Are you an active duty military?</p>
      <div class="row">
        <div class="radioBlock">
          <div class="col-md-6">
            <input type="radio" id="mil_Yes" [value]="true" name="activeMilitary" formControlName="activeMilitary">
            <label for="mil_Yes">Yes</label>
          </div>
          <div class="col-md-6">
            <input type="radio" id="mil_No" [value]="false" name="activeMilitary" formControlName="activeMilitary">
            <label for="mil_No">No</label>
          </div>
        </div>
      </div>

      <mat-error>
          <span class="validationhead" *ngIf="formSubmitted && activeMilitary.errors?.required">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
          </span>
      </mat-error>
    </div>


    <div id='emResidencyTraining' *ngIf="memberType.value == MemberType.Physician || memberType.value == MemberType.Retired">
      <h3>EM Residency Training</h3>
      <p>Are you EM residency trained in emergency medicine or pediatric emergency medicine?</p>
      <div class="row">
        <div class="radioBlock">
          <div class="col-md-6">
            <input type="radio" id="res_Yes" [value]="true" (change)="setValidationEM()" name="emResidencyTrained" formControlName="emResidencyTrained">
            <label for="res_Yes">Yes</label>
          </div>
          <div class="col-md-6">
            <input type="radio" id="res_No" [value]="false" (change)="setValidationEM()" name="emResidencyTrained" formControlName="emResidencyTrained">
            <label for="res_No">No</label>
          </div>
        </div>
      </div>

      <mat-error>
          <span class="validationhead" *ngIf="formSubmitted && emResidencyTrained.errors?.required">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
          </span>
      </mat-error>


      <div class="margin-top-40" id='startEMBefore2000' *ngIf="emResidencyTrained.value == false">

        <p>Did you start practicing emergency medicine before 2000?</p>
        <div class="row">
          <div class="radioBlock">
            <div class="col-md-6">
              <input type="radio" id="2K_Yes" [value]="true" name="startEMBefore2000" formControlName="startEMBefore2000">
              <label for="2K_Yes">Yes</label>
            </div>
            <div class="col-md-6">
              <input type="radio" id="2K_No" [value]="false" name="startEMBefore2000" formControlName="startEMBefore2000">
              <label for="2K_No">No</label>
            </div>
          </div>
        </div>

        <mat-error>
            <span class="validationhead" *ngIf="formSubmitted && startEMBefore2000.errors?.required">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
            </span>
        </mat-error>


      </div>


    </div>





    <div class="row actions">
      <div class="col-md-12">
        <button mat-raised-button class="btnSave">Save and Continue</button>
      </div>
    </div>

  </form>

  <pre *ngIf="isDevEnv"><code>{{ membershipForm.value | json }}</code></pre>

</div>
